import BaseAPI from './base.api';
import {
  type MaterialGradeRecord,
  type MaterialGradePayload,
  type BulkCreateResult,
  type MakeModelRecord,
} from 'views/DispatchImporters/MaterialGradeTonnage/types';

export default class MaterialGradeAPI extends BaseAPI {
  getAll = async (): Promise<MaterialGradeRecord[]> => {
    const response = await this.API.get('material-grade', {
      params: { customerId: this.customerId },
    });
    return Array.isArray(response.data) ? response.data : [];
  };

  create = async (
    payload: MaterialGradePayload
  ): Promise<MaterialGradeRecord> => {
    const response = await this.API.post('material-grade', payload, {
      params: { customerId: this.customerId },
    });
    return response.data;
  };

  bulkCreate = async (
    entries: MaterialGradePayload[]
  ): Promise<BulkCreateResult> => {
    const response = await this.API.post(
      'material-grade/bulk',
      { entries },
      { params: { customerId: this.customerId } }
    );
    return response.data;
  };

  update = async (
    id: string,
    patch: Partial<MaterialGradePayload>
  ): Promise<MaterialGradeRecord> => {
    const response = await this.API.put(`material-grade/${id}`, patch, {
      params: { customerId: this.customerId },
    });
    return response.data;
  };

  remove = async (id: string): Promise<void> => {
    await this.API.delete(`material-grade/${id}`, {
      params: { customerId: this.customerId },
    });
  };

  getDistinctCategories = async (): Promise<string[]> => {
    const response = await this.API.get('material-grade/distinct', {
      params: { customerId: this.customerId },
    });
    return Array.isArray(response.data) ? response.data : [];
  };

  getMakeModels = async (): Promise<MakeModelRecord[]> => {
    const response = await this.API.get(
      `make-model-details/customer/${this.customerId}`
    );
    return Array.isArray(response.data)
      ? response.data.map(
          (item: { id: string; make: string; model: string }) => ({
            id: item.id,
            make: item.make,
            model: item.model,
          })
        )
      : [];
  };
}
